import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { Images } from "../../../utils/Images";

const SubmitForm = ({ onClose }) => {
  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "rgba(0,0,0,0.4)",
        zIndex: 1300,
        paddingInline: "10px",
      }}
    >
      <Box
        sx={{
          bgcolor: "#fff",
          borderRadius: "12px",
          boxShadow: 4,
          width: "280px",
          p: "20px",
          position: "relative",
          textAlign: "center",
        }}
      >
        {/* Close Button */}
        <Button
          onClick={onClose}
          sx={{
            position: "absolute",
            top: 12,
            right: 12,
            minWidth: "auto",
            p: 0,
            bgcolor: "transparent",
            "&:hover": { bgcolor: "transparent" },
          }}
        >
          <Box
            component="img"
            src={Images.closeIcon}
            alt="Close"
            sx={{ width: 18, height: 18 }}
          />
        </Button>

        {/* Success Icon */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mb: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 44,
              height: 44,
            }}
          >
            <Box
              component="img"
              src={Images.successIcon}
              alt="Success"
              sx={{ width: "100%", height: "100%" }}
            />
          </Box>
        </Box>

        {/* Message */}
        <Typography
          variant="h4"
          sx={{
            fontWeight: 700,
            fontSize: "14px",
            maxWidth: "174px",
            margin: "0 auto",
            textAlign: "center",
            color: "#1D1D1B",
          }}
        >
          Form has been submitted successfully
        </Typography>
        <Typography
          variant="body2"
          sx={{
            fontWeight: 400,
            fontSize: "12px",
            maxWidth: "174px",
            margin: "0 auto",
            color: "#686866",
            textAlign: "center",
            marginTop: "10px",
          }}
        >
          Please check your email
        </Typography>

      </Box>
    </Box>
  );
};

export default SubmitForm;
